enum ServiceType {
  HttpClient = 'httpClient',
  API = 'api',
  BrowserStorage = 'browserStorage',
  Head = 'head',
  CredentialManager = 'credentialManager',
  EventBus = 'eventBus'
}

export default ServiceType
